<template>
  <div class="podcast">
      <div v-if="podcast.type == 'teaser'" class="podcast-teaser">
        <h3 class="podcast-teaser__text">{{podcast.name}}</h3>
        <p class="podcast-teaser__text">{{podcast.text}}</p>
      </div>
      <!-- <div v-else :data-svp-asset="'%7B%22id%22%3A'+podcast.streamURL+'%2C%22provider%22%3A%22sa%22%2C%22subscriptionUrl%22%3A%22https%3A%2F%2Fkundeportal.aftenbladet.no%2Fsa-default%2F%22%2C%22userStatus%22%3A%7B%22hasProduct%22%3Atrue%2C%22loggedIn%22%3Atrue%7D%2C%22settings%22%3A%7B%22na%22%3Atrue%7D%7D'" style="width:100%;height:100%;"> </div> -->
      <div v-else class="embed-container" style="width: 100%; height: 100%">
        <div :id="'player-'+this.podcast.streamURL"></div>
      </div>
  </div>
</template>
<script>

export default {
  props: {
    podcast: {
      type: Object,
      default: function() {
        return null;
      },
    }
  },
  methods:{
    init(){

      if(!this.podcast.type) {
        let streamid = this.podcast.streamURL;
        window.addEventListener('onSvpPlayerReady', function() {
           new SVP.Player({
              id: streamid,
              vendor: 'sa',
              node: 'player-'+streamid,
              settings: {
                na: true
              },
              userStatus: {
                hasProduct: true,
                loggedIn: true
              },
              pulse: {
                provider: 'stavangeraftenblad',
                decorator: (eventData, asset) => {
                  eventData = {
                    ...eventData,
                    object: {
                      ...eventData.object,
                      'spt:custom': {
                        url: "https://www.aftenbladet.no/magasin/i/Qm99ex/savnet-mannen-med-den-tomme-graven"
                      }
                    }
                  }
                  
                return eventData;
              },

              }
          });
      });
          (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        // beta is latest semi-stable channel, read more in section above
        // for production it's required to use latest release if possible
        js.src = "https://cdn.stream.schibsted.media/player/3.32.1/player.min.js";
        js.async = true;
        try{eval("async () => {}"),js.src=js.src.replace("player.min","player.next.min")}catch(a){}
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'svp-player-sdk'));

      }
    }
  },
  mounted(){
    this.init()
  }

  

};
</script>
<style lang="scss">
.podcast {
  padding: 0.4em 1em;
  margin: auto;
  height: 180px;
  // width: 100%;
  @include podplayer {
    height: 240px;
    width: 90%;
  }
  &-teaser {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #43413f;
    border-radius: 10px;
    

    &__text {
      text-align: center;
      color: #fff;
      
      margin: .6rem 1rem 0;
    }
  }
}
// .jw-display {
//   justify-content: flex-end !important;
// }

// .jwplayer.svp-flag-media-audio.jw-state-buffering:not(.jw-flag-casting) .jw-display, .jwplayer.svp-flag-media-audio.jw-state-playing:not(.jw-flag-casting) .jw-display, .jwplayer.svp-flag-media-audio.jw-state-paused:not(.jw-flag-casting) .jw-display, .jwplayer.svp-flag-media-audio.jw-state-complete:not(.jw-flag-casting) .jw-display {
//   display: flex !important;
//   justify-content: center !important;
// }

// .svp-cover {
//   visibility: hidden;
// }

// .jw-display-controls {

//    position: relative !important;
//    top: 0 !important;
// }

// .jw-preview {
//   background-image: none !important;

//   &::before {
//     background-color: transparent !important;  
//     background-image: none !important;
        
//     }
// }
//   .jwplayer {
//     //border: 4px #000 solid !important;
//       border: 4px #000 solid !important;
//    :focus {
//      outline: none !important;
//    }
//   }
// .jw-media {
//     // background-color: rgb(202, 202, 202) !important;  
// }

// .jw-title {
  // top: 10px !important;
  // padding-left: 0 !important;
// }
// .jw-title-primary {
//   white-space: normal !important;
// }
// .jw-title-secondary {
//   text-overflow: ellipsis !important;
// }
// .jw-controlbar {
//   left: 0 !important;
//   bottom: 10px !important;
// }
// .jw-controls {

//     bottom: 10px !important;

// }
// .jw-title-primary {
//   white-space: pre-line !important;
//   color: color('text') !important;
// }
// .jw-title-secondary {
//   color: color('text') !important;
// }
// .jw-text {
//   color: rgb(32, 32, 32) !important;
// }
// .jw-icon path {
//   // fill: #fff !important;
// }
// .jwplayer.svp-flag-media-audio .jw-controlbar .jw-icon-inline, .jwplayer.svp-flag-media-audio .jw-controlbar .jw-icon-tooltip:not(.jw-tooltip-time) {
//   color: #fff  !important;
// }

// .jw-time-tip {
//   background-color: #fff !important;
//   &::after {
//     background-color: #fff !important;

//   }
// }


// .jwplayer.svp-flag-media-audio.jw-state-idle .jw-display-icon-display .jw-icon {
//   background-color: rgb(224, 224, 224) !important;
//   margin-bottom: 0px !important;
//     @include podplayer {
//       margin-bottom: 30px !important;
//     }
// }
// .jw-display-controls.jw-reset {
//   padding-left: 0 !important;
// }
// .jw-rail {
//   background-color: rgba(194, 194, 194, 0.212) !important;
// }
// .jw-buffer {
//   background-color: rgba(0, 0, 0, 0.096) !important;
// }
// .jw-knob {
//   background-color: rgb(240, 240, 240) !important;
// }
// .jw-progress {
//   background-color: rgba(0, 0, 0, 0.205) !important;
// }

// .jw-text-elapsed,
// .jw-text-duration {
//   color: #000 !important;
// }
</style>
 